export default __webpack_public_path__ + "static/media/dev.677ea2d1.jpeg";